import { ReactNode } from 'react';
import { TableHeader } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { AddPolicyExceptionButton } from '../dialogTriggers';

interface PolicyExceptionsTableHeaderProps {
    subTitle: ReactNode;
    editable: boolean;
}

export const PolicyExceptionsTableHeader = ({ subTitle, editable }: PolicyExceptionsTableHeaderProps) => (
    <TableHeader
        title={lt('GeneralPolicyExceptionPlural')}
        subTitle={subTitle}
        rightSide={editable ? <AddPolicyExceptionButton /> : null}
    />
);
